// extracted by mini-css-extract-plugin
module.exports = {"description":"ExpertSection_description__HC1Co","border":"ExpertSection_border__RPInK"};